<template>
  <div>
    <div class="outgoing-detail" v-if="catalogs != null">
      <div class="card print" v-for="(catalogs, r) in hasil" :key="r">
        <table style="width: 100%">
          <thead>
            <!-- HEADER -->
            <div class="card">
              <div class="p-d-flex">
                <div class="p-col-10 p-grid">
                  <div class="p-col-1 image">
                    <img
                      src="/assets/images/logo.png"
                      alt="mode_logo"
                      style="margin-top: 5px"
                    />
                  </div>
                  <div
                    class="p-col-10"
                    style="margin-top: 5px; margin-left: -5px"
                  >
                    <h4 style="font-size: 15px; line-height: 0.5">
                      <b>MODE FASHION GROUP</b>
                    </h4>
                    <h6 style="font-size: 11px; line-height: 0.5">
                      Jl.Laksana
                    </h6>
                    <h6 style="font-size: 11px; line-height: 0.5">
                      Telp. (061) 6643780
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="border-header" style="margin-top: -10px"></div>
            <!-- akhir header -->
          </thead>
          <tbody>
            <h4 class="title" style="margin-top: -10px">
              <b style="font-size: 14px">Daftar Katalog</b>
            </h4>

            <div class="p-grid">
              <div class="p-col-12 p-m-auto">
                <!-- header part -->
                <table
                  width="100%"
                  class="d-flex justify-center mt-2 table-tittle"
                >
                  <td class="p-col-6" style="font-size: 12px">
                    <tr>
                      <td style="width: 150px">
                        Total Stok : {{ total_stok }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 120px">
                        Total Item : {{ total_item }}
                      </td>
                    </tr>
                  </td>
                </table>
                <!-- content part -->
                <table
                  border="1"
                  class="text-center detail-bon"
                  style="width: 100%"
                >
                  <thead style="font-size: 12px">
                    <tr style="background-color: grey">
                      <th scope="col" class="text-center" rowspan="2">No</th>
                      <th scope="col" class="text-center" rowspan="2">
                        Kode Barang
                      </th>
                      <!-- <th scope="col" class="text-center" rowspan="2">
                        Kode Kategori
                      </th> -->
                      <th scope="col" class="text-center" rowspan="2">
                        Nama Barang
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Supplier
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Harga Modal
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Harga (Rp.)
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Disc %
                      </th>
                      <th scope="col" class="text-center" rowspan="2">Stock</th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 12px" class="header">
                    <tr
                      v-for="(item, k) in catalogs"
                      :key="r * 25 + k + 1"
                      class="row-content"
                    >
                      <td>{{ r * 25 + k + 1 }}</td>
                      <td>{{ item.code }}</td>
                      <!-- <td>{{ item.cat_code }}</td> -->
                      <td>{{ item.name }}</td>
                      <td>{{ item.sup_code }} - {{ item.sup_name }}</td>
                      <td>{{ item.cap_price | currency }}</td>
                      <td>{{ item.price | currency }}</td>
                      <td>{{ item.discount }}%</td>
                      <td>{{ item.stock }}</td>
                      <!-- <td>{{ item.total | currency }}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import noImage from '../../assets/images/no-image.png'

export default {
  props: ['catalog', 'all_stock', 'total_records'],
  data() {
    return {
      no_image: noImage,
      ModeLogo: undefined,
      hasil: [],
      catalogs: this.$route.params.catalog,
      rowIndex: 0,
      total_stok: this.$route.params.all_stock,
      total_item: this.$route.params.total_records
    }
  },
  watch: {
    '$route.params': 'initializeData'
  },
  mounted() {
    this.buildDetail()
    this.initializeData()
    this.$forceUpdate()
    window.onafterprint = () => {
      window.history.back()
    }
    setTimeout(() => {
      window.print()
    }, 500)
  },

  methods: {
    initializeData() {
      this.catalogs = this.$route.params.catalog || []
      this.total_stok = this.$route.params.all_stock || 0
      this.total_item = this.$route.params.total_records || 0
    },
    buildDetail() {
      this.splitLength()
    },

    splitLength() {
      for (let i = 0; i < Math.ceil(this.catalogs.length / 25); i++) {
        this.hasil[i] = []
        for (let j = 0; j < 25; j++) {
          if (this.catalogs[this.rowIndex]) {
            this.hasil[i][j] = this.catalogs[this.rowIndex]
            this.rowIndex++
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.outgoing-detail {
  font-family: monospace;
  width: 100%;
  margin-top: -50px;
  margin-left: auto; /* to center the div */
  margin-right: auto; /* to center the div */
  box-sizing: border-box;
  overflow: hidden;
}

.title {
  padding: 15px;
  text-align: center;
}

.table-tittle {
  margin-top: -35px;
}

td {
  padding: 1px !important;
}

.border-header {
  border-top: 2px solid black;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.print table thead {
  display: table-header-group;
}

.print:nth-child(1n) {
  page-break-after: always;
}

@media print {
  .border-header {
    margin-top: -25px;
  }
  .table-tittle {
    margin-top: -35px !important ;
  }
  .detail-bon {
    border: 1px solid black;
    border-collapse: collapse;
    font-size: x-small;
    margin-bottom: -30px;
  }

  .detail-bon th,
  .detail-bon td {
    border: 1px solid black;
    padding: 1px;
    background-color: grey;
  }

  .print table thead {
    display: table-header-group;
  }

  .print:nth-child(1n) {
    page-break-after: always;
  }
}
</style>
